import React, { useState, useContext, useRef, useEffect, useCallback, useMemo } from 'react';
import {
  getFirestore, collection, query, orderBy, limit, startAfter, getDocs, doc, getDoc
} from 'firebase/firestore';
import SongItem from './SongItem';
import { useNavigate } from 'react-router-dom';
import { AppContext } from './AppContext';
import { ProfileComponentProducerSmall, ProfilecomponentProducerSmall } from './ProfileComponentProducerSmall';
import SongItemMusicVideo from './SongItemMusicVideo';


const Music = ({ onPlayVideo, isVideoPlaying, onMoveMP }) => {

  const {
    assetsSummary, setGroupedByGenresMusic, setAllAlbums,
    setAllSingles, allAlbums, allSingles, groupedByGenresMusic,
    featuredArtists, setFeaturedArtists, userId2,
      producers, setProducers, dataFeaturedMusic, setDataFeaturedMusic,
      featuredSongs, setFeaturedSongs,
      musicVideos, setMusicVideos

  } = useContext(AppContext);
  const [groupedByGenres, setGroupedByGenres] = useState({});
  const [lastGenreDocs, setLastGenreDocs] = useState({});
  const [loading, setLoading] = useState(true);
  const [newReleases, setNewReleases] = useState([]);
  const [isFetchingMore, setIsFetchingMore] = useState(false);
  const [isFetchingMoreGenre, setIsFetchingMoreGenre] = useState({});
  const [playlists, setPlaylists] = useState([]);
  const firestore = getFirestore();
  const navigate = useNavigate();
  const [lastProducersDoc, setLastProducersDoc] = useState(null);
  const [lastFeaturedMusicDoc, setLastFeaturedMusicDoc] = useState(null);
  const [lastFeaturedArtistDoc, setLastFeaturedArtistDoc] = useState(null);

  const millis = ts =>
    !ts ? 0
    : typeof ts === 'number' ? ts
    : typeof ts === 'string' ? new Date(ts).getTime()
    : ts.toMillis ? ts.toMillis()
    : 0;

  const featuredMusicScrollRef = useRef(null);
  const featuredSongsScrollRef = useRef(null);
  const newReleasesScrollRef = useRef(null);
  const genreScrollRefs = useMemo(() => ({}), []);




  
  const [visibleCount, setVisibleCount] = useState(8);

  const mergedSingles = useMemo(() => {
    if (!assetsSummary || !Array.isArray(assetsSummary)) return [];
  
    const nftSingles = assetsSummary
      .filter(a => !a.isAlbum)
      .map(a => ({ ...a, contentId: a.id, isNFT: true }));
  
    const uniq = {};
    [...allSingles, ...nftSingles].forEach(s => {
      uniq[s.contentId ?? s.id] = s;
    });
  
    return Object.values(uniq).sort(
      (a, b) => millis(b.releaseTimestamp) - millis(a.releaseTimestamp)
    );
  }, [assetsSummary, allSingles]);

    const albumNameKey = (a) => {
    const name =
      a?.AlbumName ??
      a?.albumName ??
      a?.title ??
      a?.name ??
      a?.AlbumTitle ??
      a?.albumTitle ??
      '';
    return String(name).trim().toLowerCase();
  };

  const assetsAlbumsByName = useMemo(() => {
    const map = new Map();
    const src = Array.isArray(assetsSummary) ? assetsSummary : [];

    src
      .filter(a => a?.isAlbum)
      .forEach(a => {
        const key = albumNameKey(a);
        if (!key) return;
        map.set(key, { ...a, contentId: a.id, isNFT: true });
      });

    return map;
  }, [assetsSummary]);

  const newAlbumsDisplay = useMemo(() => {
    const base = Array.isArray(featuredSongs) ? featuredSongs : [];

    // 1) Replace any base albums with assetsSummary version when names match
    const replaced = base.map(album => {
      const key = albumNameKey(album);
      const replacement = key ? assetsAlbumsByName.get(key) : null;
      return replacement || album;
    });

    // 2) Append any remaining assetsSummary albums not already represented by name
    const seen = new Set(replaced.map(a => albumNameKey(a)).filter(Boolean));
    const extras = [];
    for (const [, nftAlbum] of assetsAlbumsByName.entries()) {
      const key = albumNameKey(nftAlbum);
      if (!key) continue;
      if (seen.has(key)) continue;
      seen.add(key);
      extras.push(nftAlbum);
    }

    return [...replaced, ...extras].sort(
      (a, b) => millis(b.releaseTimestamp) - millis(a.releaseTimestamp)
    );
  }, [featuredSongs, assetsAlbumsByName]);


  
  
  const pagedSingles = useMemo(
    () => mergedSingles.slice(0, visibleCount),
    [mergedSingles, visibleCount]
  );



  const handlePlaylistSelection = (selectedPlaylist) => {
    // Implement the function logic here
  };

  const handlePressBegins = async (song) => { 
            if (userId2 === "guest") {
      navigate('/login');
      return;
        }
    if (song?.isNFT || song?.editions || song?.tier) {
      const clonedSong = JSON.parse(JSON.stringify(song));
      navigate(`/dat/${song.id}`, { state: { clonedSong } });
    } else {
    const clonedSong = JSON.parse(JSON.stringify(song));
    navigate('/view-song', { state: { song: clonedSong } });
    }
  };

  const handlePressProfile = (profile) => {
    const clonedProfile = JSON.parse(JSON.stringify(profile));
    const targetRoute = profile.userId === userId2 ? '/mydat/profile' : `/userprofile/${profile.username}`;
    navigate(targetRoute, { state: { profile: clonedProfile, fromURL: false } });
  };

  const renderPlaylistItem = ({ item }) => (
    <div onClick={() => handlePlaylistSelection(item)} style={styles.playlistItem}>
      <img src={item.ArtworkURL} alt="" style={styles.coverImage} />
    </div>
  );

/* replace renderItem */
const renderItem = useCallback(({ item }) => {
  if (item === 'loading') {
    return (
      <div style={styles.cardWrapper}>
        <div style={styles.horizontalTouchable}>
          <div style={styles.songArtworkPlaceholder}>Loading…</div>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.cardWrapper}>
<SongItem
  item={item}
  onPress={handlePressBegins}
  editControlsStyle={styles.editControls}
  calendarPopupStyle={styles.calendarPopup}
  confirmButtonStyle={styles.confirmButton}
  compactEditor
/>

    </div>
  );
}, [handlePressBegins]);



  const genresList = [
    { label: "Rap", value: "hip_hop_rap" },
    { label: "Rock", value: "rock" },
    { label: "Country", value: "country" },
    { label: "Pop", value: "pop" },
    { label: "Alternative", value: "Alternative" },
    { label: "Blues", value: "blues" },
    { label: "R&B/Soul", value: "rnb_soul" },
    { label: "Metal", value: "metal" },
    { label: "Indie", value: "indie" },
    { label: "Folk", value: "folk" },
    { label: "Classical", value: "classical" },
    { label: "Electronic/Dance", value: "electronic_dance" },
    { label: "Jazz", value: "jazz" },
    { label: "Latin", value: "latin" },
    { label: "Reggae", value: "reggae" },
    { label: "World/International", value: "world_international" }
  ];





  const fetchMoreFeaturedMusic = async (lastDoc) => {
    
  

    setIsFetchingMore(false);
    
  };


  const fetchUserProfile = async (userId) => {
    try {
      const userDocRef = doc(firestore, 'users', userId);
      const userDoc = await getDoc(userDocRef);
      if (userDoc.exists()) {
        handlePressProfile(userDoc.data());
      } else {
        
      }
    } catch (error) {
      console.error('Error fetching user profile:', error);
    }
  };


  const FETCH_SIZE = 8;

  const fetchMoreFeaturedSongs = () => {
    if (isFetchingMore) return;
  
    const nextSlice = allAlbums.slice(
      featuredSongs.length,
      featuredSongs.length + 8
    );
    if (nextSlice.length === 0) return;
  
    setIsFetchingMore(true);
    setFeaturedSongs(prev => {
      const existingIds = new Set(prev.map(item => item.contentId));
      const filteredNext = nextSlice.filter(
        item => !existingIds.has(item.contentId)
      );
      return [...prev, ...filteredNext];
    });
    setIsFetchingMore(false);
  };
  

  const fetchMoreNewReleases = async (lastDoc) => {
    if (visibleCount < mergedSingles.length) {
      setVisibleCount(prev => prev + 8);
    }
  };

  const fetchMoreGenreSongs = async (genre) => {

  };

  const handleScroll = (ref, fetchMoreFunc, lastItem) => {
    if (!ref.current) return;

    const { scrollLeft, scrollWidth, clientWidth } = ref.current;
    

    if (scrollLeft + clientWidth >= scrollWidth - 5) {
      
      setTimeout(() => fetchMoreFunc(lastItem), 100); // Pass the last item rendered
    }
  };

  // Add scroll event listeners for featured music, featured songs, and new releases
  useEffect(() => {
    const handleFeaturedMusicScroll = () => handleScroll(featuredMusicScrollRef, fetchMoreFeaturedMusic, dataFeaturedMusic[dataFeaturedMusic.length - 1]);
    const handleFeaturedSongsScroll = () => handleScroll(featuredSongsScrollRef, fetchMoreFeaturedSongs, featuredSongs[featuredSongs.length - 1]);
    const handleNewReleasesScroll = () => handleScroll(newReleasesScrollRef, fetchMoreNewReleases, newReleases[newReleases.length - 1]);

    if (featuredMusicScrollRef.current) {
      featuredMusicScrollRef.current.addEventListener('scroll', handleFeaturedMusicScroll);
      
    }
    if (featuredSongsScrollRef.current) {
      featuredSongsScrollRef.current.addEventListener('scroll', handleFeaturedSongsScroll);
      
    }
    if (newReleasesScrollRef.current) {
      newReleasesScrollRef.current.addEventListener('scroll', handleNewReleasesScroll);
      
    }

    return () => {
      if (featuredMusicScrollRef.current) {
        featuredMusicScrollRef.current.removeEventListener('scroll', handleFeaturedMusicScroll);
        
      }
      if (featuredSongsScrollRef.current) {
        featuredSongsScrollRef.current.removeEventListener('scroll', handleFeaturedSongsScroll);
        
      }
      if (newReleasesScrollRef.current) {
        newReleasesScrollRef.current.removeEventListener('scroll', handleNewReleasesScroll);
        
      }
    };
  }, [dataFeaturedMusic, featuredSongs, newReleases]);







  const removeDuplicates = (array) => {
    const seen = new Set();
    return array.filter(item => {
      const key = item.id ?? item.userId;   // fall back to userId if id is undefined
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
  };

  const handleNavigateSeeAll = (category) => {
    let data;
    if (category === 'Featured Music') data = dataFeaturedMusic;
    else if (category === 'New Albums') data = allAlbums;
    else if (category === 'New Singles') data = mergedSingles;
    else if (category === 'Music Videos') data = musicVideos;
    else {
      const genreObj = genresList.find(g => g.label === category);
      data = genreObj ? groupedByGenresMusic[genreObj.value] || [] : [];
    }
    navigate('/music-all', { state: { category, data } });
  };
  

  const handleNavigateShowcase = () => {
  navigate('/showcase');
};


  return (
    <div style={styles.fullScreen}>
      <div style={styles.scrollContainer}>

      <div style={styles.horizontalSection}>
  <div style={styles.sectionHeader}>
    <p style={styles.horizontalText}>Featured Artists</p>
  </div>
  <div style={styles.horizontalScroll}>
    {featuredArtists.map(profile => (
      <div key={profile.userId} style={styles.profileItem}>
        <ProfileComponentProducerSmall
          userProfile={profile}
          onClick={() => handlePressProfile(profile)}
        />
      </div>
    ))}
  </div>
</div>
        <div style={styles.horizontalSection}>
          <div style={styles.horizontalScroll} ref={featuredMusicScrollRef}>
            {/* Render featured music */}
          </div>
        </div>
        
        {['Featured Music', 'New Albums', 'New Singles'].map((text, index) => (
          <div key={index} style={styles.horizontalSection}>
<div style={styles.sectionHeader}>
  <p style={styles.horizontalText}>{text}</p>
  <button
    style={styles.seeAllButton}
    onClick={() => handleNavigateSeeAll(text)}
  >
    See All
  </button>
</div>

            <div style={styles.horizontalScroll} ref={index === 0 ? featuredMusicScrollRef : index === 1 ? featuredSongsScrollRef : newReleasesScrollRef}>
              {(index === 0 ? dataFeaturedMusic : index === 1 ? newAlbumsDisplay : pagedSingles).map((item, i, arr) => {
                if (i === arr.length - 1) {
                  if (index === 0) {
                    return (
                      <div key={item.id} id="lastFeaturedMusicItem">
                        {renderItem({ item })}
                      </div>
                    );
                  } else if (index === 1) {
                    return (
                      <div key={item.id} id="lastFeaturedSongItem">
                        {renderItem({ item })}
                      </div>
                    );
                  } else {
                    return (
                      <div key={item.id} id="lastNewReleaseItem">
                        {renderItem({ item })}
                      </div>
                    );
                  }
                }
                return renderItem({ item });
              })}
            </div>
          </div>
        ))}

        {musicVideos && musicVideos.length > 0 && (
  <div style={styles.horizontalSection}>
    <div style={styles.sectionHeader}>
      <p style={styles.horizontalText}>Music Videos</p>
      <button
        style={styles.seeAllButton}
        onClick={() => handleNavigateSeeAll('Music Videos')}
      >
        See All
      </button>
    </div>

    <div style={styles.horizontalScroll}>
{musicVideos.map((item) => (
  <SongItemMusicVideo
    key={item.contentId || item.id}
    item={item}
    onPress={handlePressBegins}
  />
))}

    </div>
  </div>
)}


<div style={styles.horizontalSection}>
  <div style={styles.sectionHeader}>
    <p style={styles.horizontalText}>Producers</p>
  </div>
  <div style={styles.horizontalScroll}>
    {producers.map(profile => (
      <div key={profile.userId} style={styles.profileItem}>
        <ProfileComponentProducerSmall
          userProfile={profile}
          onClick={() => handlePressProfile(profile)}
        />
      </div>
    ))}
  </div>
</div>
  
        {groupedByGenresMusic.hip_hop_rap && groupedByGenresMusic.hip_hop_rap.length > 0 && (
          <div style={styles.horizontalSection}>
              <div style={styles.sectionHeader}>
            <p style={styles.horizontalText}>Rap</p>
            <button
      style={styles.seeAllButton}
      onClick={() => handleNavigateSeeAll('Rap')}
    >
      See All
    </button>
    </div>
            <div style={styles.horizontalScroll} ref={el => genreScrollRefs.hip_hop_rap = { current: el }}>
              {groupedByGenresMusic.hip_hop_rap.map((item, i, arr) => {
                if (i === arr.length - 1) {
                  return (
                    <div key={item.id} id="lastHipHopRapItem">
                      {renderItem({ item })}
                    </div>
                  );
                }
                return renderItem({ item });
              })}
            </div>
          </div>
        )}
        {groupedByGenresMusic.rock && groupedByGenresMusic.rock.length > 0 && (
          <div style={styles.horizontalSection}>
<div style={styles.sectionHeader}>
  <p style={styles.horizontalText}>Rock</p>
  <button
    style={styles.seeAllButton}
    onClick={() => handleNavigateSeeAll('Rock')}
  >
    See All
  </button>
</div>
            <div style={styles.horizontalScroll} ref={el => genreScrollRefs.rock = { current: el }}>
              {groupedByGenresMusic.rock.map((item, i, arr) => {
                if (i === arr.length - 1) {
                  return (
                    <div key={item.id} id="lastRockItem">
                      {renderItem({ item })}
                    </div>
                  );
                }
                return renderItem({ item });
              })}
            </div>
          </div>
        )}
        {groupedByGenresMusic.country && groupedByGenresMusic.country.length > 0 && (
          <div style={styles.horizontalSection}>
<div style={styles.sectionHeader}>
  <p style={styles.horizontalText}>Country</p>
  <button
    style={styles.seeAllButton}
    onClick={() => handleNavigateSeeAll('Country')}
  >
    See All
  </button>
</div>
            <div style={styles.horizontalScroll} ref={el => genreScrollRefs.country = { current: el }}>
              {groupedByGenresMusic.country.map((item, i, arr) => {
                if (i === arr.length - 1) {
                  return (
                    <div key={item.id} id="lastCountryItem">
                      {renderItem({ item })}
                    </div>
                  );
                }
                return renderItem({ item });
              })}
            </div>
          </div>
        )}
        {groupedByGenresMusic.pop && groupedByGenresMusic.pop.length > 0 && (
          <div style={styles.horizontalSection}>
<div style={styles.sectionHeader}>
  <p style={styles.horizontalText}>Pop</p>
  <button
    style={styles.seeAllButton}
    onClick={() => handleNavigateSeeAll('Pop')}
  >
    See All
  </button>
</div>
            <div style={styles.horizontalScroll} ref={el => genreScrollRefs.pop = { current: el }}>
              {groupedByGenresMusic.pop.map((item, i, arr) => {
                if (i === arr.length - 1) {
                  return (
                    <div key={item.id} id="lastPopItem">
                      {renderItem({ item })}
                    </div>
                  );
                }
                return renderItem({ item });
              })}
            </div>
          </div>
        )}
        {groupedByGenresMusic.Alternative && groupedByGenresMusic.Alternative.length > 0 && (
          <div style={styles.horizontalSection}>
<div style={styles.sectionHeader}>
  <p style={styles.horizontalText}>Alternative</p>
  <button
    style={styles.seeAllButton}
    onClick={() => handleNavigateSeeAll('Alternative')}
  >
    See All
  </button>
</div>
            <div style={styles.horizontalScroll} ref={el => genreScrollRefs.Alternative = { current: el }}>
              {groupedByGenresMusic.Alternative.map((item, i, arr) => {
                if (i === arr.length - 1) {
                  return (
                    <div key={item.id} id="lastAlternativeItem">
                      {renderItem({ item })}
                    </div>
                  );
                }
                return renderItem({ item });
              })}
            </div>
          </div>
        )}
        {groupedByGenresMusic.blues && groupedByGenresMusic.blues.length > 0 && (
          <div style={styles.horizontalSection}>
<div style={styles.sectionHeader}>
  <p style={styles.horizontalText}>Blues</p>
  <button
    style={styles.seeAllButton}
    onClick={() => handleNavigateSeeAll('Blues')}
  >
    See All
  </button>
</div>
            <div style={styles.horizontalScroll} ref={el => genreScrollRefs.blues = { current: el }}>
              {groupedByGenresMusic.blues.map((item, i, arr) => {
                if (i === arr.length - 1) {
                  return (
                    <div key={item.id} id="lastBluesItem">
                      {renderItem({ item })}
                    </div>
                  );
                }
                return renderItem({ item });
              })}
            </div>
          </div>
        )}
        {groupedByGenresMusic.rnb_soul && groupedByGenresMusic.rnb_soul.length > 0 && (
          <div style={styles.horizontalSection}>
<div style={styles.sectionHeader}>
  <p style={styles.horizontalText}>R&B/Soul</p>
  <button
    style={styles.seeAllButton}
    onClick={() => handleNavigateSeeAll('R&B/Soul')}
  >
    See All
  </button>
</div>
            <div style={styles.horizontalScroll} ref={el => genreScrollRefs.rnb_soul = { current: el }}>
              {groupedByGenresMusic.rnb_soul.map((item, i, arr) => {
                if (i === arr.length - 1) {
                  return (
                    <div key={item.id} id="lastRnbSoulItem">
                      {renderItem({ item })}
                    </div>
                  );
                }
                return renderItem({ item });
              })}
            </div>
          </div>
        )}
        {groupedByGenresMusic.metal && groupedByGenresMusic.metal.length > 0 && (
          <div style={styles.horizontalSection}>
<div style={styles.sectionHeader}>
  <p style={styles.horizontalText}>Metal</p>
  <button
    style={styles.seeAllButton}
    onClick={() => handleNavigateSeeAll('Metal')}
  >
    See All
  </button>
</div>

            <div style={styles.horizontalScroll} ref={el => genreScrollRefs.metal = { current: el }}>
              {groupedByGenresMusic.metal.map((item, i, arr) => {
                if (i === arr.length - 1) {
                  return (
                    <div key={item.id} id="lastMetalItem">
                      {renderItem({ item })}
                    </div>
                  );
                }
                return renderItem({ item });
              })}
            </div>
          </div>
        )}
        {groupedByGenresMusic.indie && groupedByGenresMusic.indie.length > 0 && (
          <div style={styles.horizontalSection}>
<div style={styles.sectionHeader}>
  <p style={styles.horizontalText}>Indie</p>
  <button
    style={styles.seeAllButton}
    onClick={() => handleNavigateSeeAll('Indie')}
  >
    See All
  </button>
</div>
            <div style={styles.horizontalScroll} ref={el => genreScrollRefs.indie = { current: el }}>
              {groupedByGenresMusic.indie.map((item, i, arr) => {
                if (i === arr.length - 1) {
                  return (
                    <div key={item.id} id="lastIndieItem">
                      {renderItem({ item })}
                    </div>
                  );
                }
                return renderItem({ item });
              })}
            </div>
          </div>
        )}
        {groupedByGenresMusic.folk && groupedByGenresMusic.folk.length > 0 && (
          <div style={styles.horizontalSection}>
<div style={styles.sectionHeader}>
  <p style={styles.horizontalText}>Folk</p>
  <button
    style={styles.seeAllButton}
    onClick={() => handleNavigateSeeAll('Folk')}
  >
    See All
  </button>
</div>
            <div style={styles.horizontalScroll} ref={el => genreScrollRefs.folk = { current: el }}>
              {groupedByGenresMusic.folk.map((item, i, arr) => {
                if (i === arr.length - 1) {
                  return (
                    <div key={item.id} id="lastFolkItem">
                      {renderItem({ item })}
                    </div>
                  );
                }
                return renderItem({ item });
              })}
            </div>
          </div>
        )}
        {groupedByGenresMusic.classical && groupedByGenresMusic.classical.length > 0 && (
          <div style={styles.horizontalSection}>
<div style={styles.sectionHeader}>
  <p style={styles.horizontalText}>Classical</p>
  <button
    style={styles.seeAllButton}
    onClick={() => handleNavigateSeeAll('Classical')}
  >
    See All
  </button>
</div>
            <div style={styles.horizontalScroll} ref={el => genreScrollRefs.classical = { current: el }}>
              {groupedByGenresMusic.classical.map((item, i, arr) => {
                if (i === arr.length - 1) {
                  return (
                    <div key={item.id} id="lastClassicalItem">
                      {renderItem({ item })}
                    </div>
                  );
                }
                return renderItem({ item });
              })}
            </div>
          </div>
        )}
        {groupedByGenresMusic.electronic_dance && groupedByGenresMusic.electronic_dance.length > 0 && (
          <div style={styles.horizontalSection}>
<div style={styles.sectionHeader}>
  <p style={styles.horizontalText}>Electronic/Dance</p>
  <button
    style={styles.seeAllButton}
    onClick={() => handleNavigateSeeAll('Electronic/Dance')}
  >
    See All
  </button>
</div>
            <div style={styles.horizontalScroll} ref={el => genreScrollRefs.electronic_dance = { current: el }}>
              {groupedByGenresMusic.electronic_dance.map((item, i, arr) => {
                if (i === arr.length - 1) {
                  return (
                    <div key={item.id} id="lastElectronicDanceItem">
                      {renderItem({ item })}
                    </div>
                  );
                }
                return renderItem({ item });
              })}
            </div>
          </div>
        )}
        {groupedByGenresMusic.jazz && groupedByGenresMusic.jazz.length > 0 && (
          <div style={styles.horizontalSection}>
<div style={styles.sectionHeader}>
  <p style={styles.horizontalText}>Jazz</p>
  <button
    style={styles.seeAllButton}
    onClick={() => handleNavigateSeeAll('Jazz')}
  >
    See All
  </button>
</div>
            <div style={styles.horizontalScroll} ref={el => genreScrollRefs.jazz = { current: el }}>
              {groupedByGenresMusic.jazz.map((item, i, arr) => {
                if (i === arr.length - 1) {
                  return (
                    <div key={item.id} id="lastJazzItem">
                      {renderItem({ item })}
                    </div>
                  );
                }
                return renderItem({ item });
              })}
            </div>
          </div>
        )}
        {groupedByGenresMusic.latin && groupedByGenresMusic.latin.length > 0 && (
          <div style={styles.horizontalSection}>
<div style={styles.sectionHeader}>
  <p style={styles.horizontalText}>Latin</p>
  <button
    style={styles.seeAllButton}
    onClick={() => handleNavigateSeeAll('Latin')}
  >
    See All
  </button>
</div>
            <div style={styles.horizontalScroll} ref={el => genreScrollRefs.latin = { current: el }}>
              {groupedByGenresMusic.latin.map((item, i, arr) => {
                if (i === arr.length - 1) {
                  return (
                    <div key={item.id} id="lastLatinItem">
                      {renderItem({ item })}
                    </div>
                  );
                }
                return renderItem({ item });
              })}
            </div>
          </div>
        )}
        {groupedByGenresMusic.reggae && groupedByGenresMusic.reggae.length > 0 && (
          <div style={styles.horizontalSection}>
<div style={styles.sectionHeader}>
  <p style={styles.horizontalText}>Reggae</p>
  <button
    style={styles.seeAllButton}
    onClick={() => handleNavigateSeeAll('Reggae')}
  >
    See All
  </button>
</div>
            <div style={styles.horizontalScroll} ref={el => genreScrollRefs.reggae = { current: el }}>
              {groupedByGenresMusic.reggae.map((item, i, arr) => {
                if (i === arr.length - 1) {
                  return (
                    <div key={item.id} id="lastReggaeItem">
                      {renderItem({ item })}
                    </div>
                  );
                }
                return renderItem({ item });
              })}
            </div>
          </div>
        )}
        {groupedByGenresMusic.world_international && groupedByGenresMusic.world_international.length > 0 && (
          <div style={styles.horizontalSection}>
<div style={styles.sectionHeader}>
  <p style={styles.horizontalText}>World/International</p>
  <button
    style={styles.seeAllButton}
    onClick={() => handleNavigateSeeAll('World/International')}
  >
    See All
  </button>
</div>
            <div style={styles.horizontalScroll} ref={el => genreScrollRefs.world_international = { current: el }}>
              {groupedByGenresMusic.world_international.map((item, i, arr) => {
                if (i === arr.length - 1) {
                  return (
                    <div key={item.id} id="lastWorldInternationalItem">
                      {renderItem({ item })}
                    </div>
                  );
                }
                return renderItem({ item });
              })}
            </div>
          </div>
        )}
        <div style={styles.extraSpace}></div>
      </div>
    </div>
  );
  
};

const styles = {
  fullScreen: {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    overflow: 'hidden',
    width: '100%',
    paddingLeft: '10px',
    paddingRight: '10px',
  },
  profileItem: {
    display: 'inline-block',
    marginRight: '10px',
  },
  sectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  seeAllButton: {
    background: 'none',
    border: 'none',
    color: '#62fbfa',
    marginRight: '16px',
    fontSize: '1rem',
    fontWeight: 'bold',
    cursor: 'pointer',
  },
  extraSpace: {
    height: '300px',
  },
  scrollContainer: {
    flex: 1,
    overflowY: 'auto',
    width: '105%',
  },
  horizontalSection: {
    marginBottom: '-10px',
  },
  horizontalText: {
    fontSize: '20px',
    fontWeight: 'bold',
    color: 'white',
  },
  horizontalScroll: {
    display: 'flex',
    overflowX: 'auto',
    whiteSpace: 'nowrap',
    justifyContent: 'flex-start',
    paddingRight: '28px',
  },
  
  
  playlistItem: {
    display: 'inline-block', // Change to inline-block to align items horizontally
    flexDirection: 'column',
    alignItems: 'center',
    marginRight: '10px',
    width: '100px',
  },
  coverImage: {
    width: '100px',
    height: '100px',
    borderRadius: '10px',
  },
  itemContainer: {
    display: 'inline-block', // Change to inline-block to align items horizontally
    marginRight: '10px',
    width: '100px',
  },
  horizontalTouchable: {
    width: '100px',
    height: '100px',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'transparent',
  },
  songArtworkPlaceholder: {
    width: '100%',
    height: '100%',
    borderRadius: '8px',
    backgroundColor: '#cccccc',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
cardWrapper: {
  flex: '0 0 auto',
  width: '100px',
  marginRight: '10px',
  position: 'relative'
},

horizontalScroll: {
  display: 'flex',
  overflowX: 'auto',
  overflowY: 'visible',
  whiteSpace: 'nowrap',
  justifyContent: 'flex-start',
  paddingRight: '28px',
  position: 'relative'
},
editControls: {
  position: 'absolute',
  top: '100%',
  left: 0,
  zIndex: 9999,
  backgroundColor: '#222',
  border: '1px solid #444',
  borderRadius: '6px',
  padding: '4px 6px',
  fontSize: '12px',
  transform: 'scale(0.9)'
},
calendarPopup: {
  fontSize: '12px',
  zIndex: 10000, 
  backgroundColor: '#333',
  borderRadius: '6px',
  padding: '6px',
  maxWidth: '200px'
},
confirmButton: {
  fontSize: '12px',
  padding: '4px 8px',
  borderRadius: '4px',
  marginTop: '6px'
},
musicVideoItem: {
  display: 'inline-block',
  marginRight: '10px',
  verticalAlign: 'top'
},
videoFrame: {
  position: 'relative',
  width: '360px',
  maxWidth: '20vw',
  paddingTop: '56.25%',   // 16:9 aspect
  borderRadius: '8px',
  overflow: 'hidden',
  backgroundColor: '#cccccc',
  marginBottom: '10px'
},
videoFill: {
  position: 'absolute',
  inset: 0,
  width: '100%',
  height: '100%',
  objectFit: 'cover'
},
videoThumbnailPlaceholder: {
  width: '360px',
  maxWidth: '38vw',
  paddingTop: '56.25%',   // 16:9 aspect
  borderRadius: '8px',
  backgroundColor: '#cccccc'
},
artistName: { color: 'white', fontSize: '0.95rem', fontWeight: 'bold', margin: '0', lineHeight: '1.1' },
songName:   { color: '#b8b8b8', fontSize: '0.9rem',  margin: '2px 0 0',      lineHeight: '1.1' },

horizontalSectionGiveaway: {
  margin: '12px 0 1px',
  padding: '14px 16px',
  borderRadius: '12px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center', 
  gap: '10px',
  textAlign: 'center',
},

horizontalTextCentered: {
  margin: 0,
  fontSize: '22px',
  fontWeight: 800,
  letterSpacing: '0.6px',
  color: 'white',
},

showcaseSignupButton: {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '10px 16px',


  background: 'rgba(98, 251, 250, 0.08)',
  cursor: 'pointer',
  outline: 'none',

  transition: 'transform 120ms ease',
},

showcaseSignupText: {
  fontSize: '14px',
  fontWeight: 700,
  textTransform: 'uppercase',
  letterSpacing: '0.4px',
  color: '#e7ffff',
  userSelect: 'none',
},

hereWord: {
  color: '#62fbfa',
  textDecoration: 'underline',
},

showcaseSignupButton: {
  background: 'none',
  border: 'none',
  padding: 0,
  margin: 0,
  cursor: 'pointer',
  outline: 'none',
  display: 'inline',
  color: 'inherit',
  font: 'inherit',
  textAlign: 'center',
  transition: 'opacity 0.15s ease',
},
showcaseSignupButtonHover: {
  opacity: 0.8,
},
showcaseSignupText: {
  fontSize: '14px',
  fontWeight: 700,
  textTransform: 'uppercase',
  letterSpacing: '0.4px',
  color: '#e7ffff',
  userSelect: 'none',
},


};

export default Music;
